<template>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
        <span :class="`inline-flex justify-center items-center px-2.5 py-1 rounded-md text-sm font-medium leading-5 ${colour} text-white transition-colors duration-300`">
            <span class="block text-center">
                <template v-if="total > 2">
                    {{ total }} Seats Available
                </template>

                <template v-else-if="total > 0">
                    Only {{ total }} {{ total !== 1 ? 'Seats' : 'Seat' }} Left
                </template>

                <template v-else>
                    Fully Booked
                </template>
            </span>
        </span>
        <span class="inline-flex justify-center items-center px-2.5 py-1 rounded-md text-sm font-medium leading-5 bg-gray-200 text-gray-800">
            <span class="block text-center">{{ member < 0 ? 0 : member }} Member Seats Available</span>
        </span>
    </div>
</template>

<script>
	export default {
        props: {
            total: {
                type: Number,
                required: true,
            },

            member: {
                type: Number,
                required: true,
            },
        },

        computed: {
            colour() {
                if (this.total >= 5) return 'bg-green-500';

                return this.total >= 3 ? 'bg-yellow-300' : 'bg-red-500';
            },

            background() {

            },
        }
	}
</script>
